export const AVAILABLE_MAPS = ['hot_map', 'cold_map']
export const TILESET = 'tiles';
export const LAYER   = 'Blocks';

export const TILE_SIZE = 35;
export const EXPLOSION_TIME = 2000;
export const PING = 100;

export const SPEED = 0
export const POWER = 1
export const DELAY = 2

export const INITIAL_SPEED = 150
export const STEP_SPEED = 50
export const MAX_SPEED = 350
export const INITIAL_DELAY = 2000
export const STEP_DELAY = 500
export const MIN_DELAY = 500
export const INITIAL_POWER = 1
export const STEP_POWER = 1
